import { useState } from 'react';

import { useUserSource } from '@/hooks/rxdb-models';
import { ContextItem } from '@/components/context-item';
import { AiContextModalFrame } from '@/components/ai-context-modal-frame';

import styles from './audio-preview-modal.module.scss';

export const AudioPreviewModal = (props: AudioPreviewModalProps) => {
  const { open, sourceId, onClose } = props;

  // Callers clear sourceId on close, but the Modal fades out for 300ms; keep the last id so the
  // card stays rendered instead of collapsing the modal to its header mid-transition. The id is
  // dropped once the frame is gone so the source subscription does not outlive the modal.
  const [shownSourceId, setShownSourceId] = useState(sourceId);
  if (sourceId && sourceId !== shownSourceId) setShownSourceId(sourceId);

  const { data: userSource } = useUserSource(shownSourceId);

  return (
    <AiContextModalFrame open={open} onClose={onClose} onClosed={() => setShownSourceId(undefined)} showFooter={false}>
      <div className={styles.audioPreview}>
        {userSource && (
          <ContextItem
            expandable
            autoLoadAudio
            playbackEnabled={open}
            showMenu={false}
            id={userSource.id}
            name={userSource.name}
            error={userSource.error}
            sourceType={userSource.sourceType}
            source={userSource.source}
            updatedAt={userSource.updatedAt}
            syncStatus={userSource.syncStatus}
            parsedContent={userSource.parsedContent}
          />
        )}
      </div>
    </AiContextModalFrame>
  );
};

export interface AudioPreviewModalProps {
  open: boolean;
  sourceId?: string;
  onClose: () => void;
}
